import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DropdownTree from '@adsk/bim360-matrix-react-dropdown-tree';
import locationApiTreeParser from './helpers/locationApiTreeParser';

/***
 * A LocationPicker component
 */
class LocationPicker extends PureComponent {
  render() {
    const { locationApiPayload, ...rest } = this.props;
    let rootDirectChildren = null;
    if (!this.props.loadingError && !this.props.isLoading) {
      const preparedTree = locationApiTreeParser(locationApiPayload).tree;
      rootDirectChildren = preparedTree && preparedTree.children ? preparedTree.children : [];
    }

    return <DropdownTree {...rest} tree={rootDirectChildren} />;
  }
}

LocationPicker.propTypes = {
  ...DropdownTree.propTypes,
  /**
   * This is the payload coming DIRECTLY from the LBS Service as-is, not any manipulation of it.
   */
  locationApiPayload: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      parentId: PropTypes.string,
      name: PropTypes.string,
      order: PropTypes.number
    })
  ),
  /**
   * Whether locations are still loading
   */
  isLoading: PropTypes.bool,
  /**
   * Whether there was an error loading locations
   */
  loadingError: PropTypes.bool
};

export default LocationPicker;
